<template>
  <div class="app-container">
    <NavigationBar v-if="isAuthenticated" />
    <div :class="{ 'content-wrapper': isAuthenticated }" class="content-area">
      <router-view />
    </div>

    <!-- Global Email Composer Modal (Reply Only) -->
    <EmailComposer
      :is-open="composerModalOpen"
      :original-message="originalMessage"
      @close="closeComposer"
      @sent="handleEmailSent"
    />
  </div>
</template>

<script>
import { computed, ref, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import NavigationBar from "@/components/NavigationBar.vue";
import EmailComposer from "@/components/EmailComposer.vue";

export default {
  name: "App",
  components: {
    NavigationBar,
    EmailComposer,
  },
  setup() {
    const store = useStore();
    const isAuthenticated = computed(() => store.getters.isAuthenticated);

    // Initialize user data when app loads
    onMounted(async () => {
      await store.dispatch("initAuth");
      document.addEventListener("open-email-composer", openComposer);
    });

    // Email composer state (Reply only)
    const composerModalOpen = ref(false);
    const originalMessage = ref(null);

    const openComposer = (event) => {
      const {
        mode = "reply",
        message = null,
        conversation = null,
        lastReceivedMessage = null,
      } = event.detail || {};

      // Only allow reply mode
      if (mode !== "reply" || !message) {
        console.warn("Only reply mode is supported");
        return;
      }

      // Attach conversation data and last received message to the message if available
      if (conversation || lastReceivedMessage) {
        originalMessage.value = {
          ...message,
          conversation: conversation,
          lastReceivedMessage: lastReceivedMessage,
        };
      } else {
        originalMessage.value = message;
      }
      composerModalOpen.value = true;
    };

    const closeComposer = () => {
      composerModalOpen.value = false;
      originalMessage.value = null;
    };

    const handleEmailSent = (sentMessage) => {
      // You can add global handling here, like showing a notification
      console.log("Reply sent:", sentMessage);
      // Optionally refresh message lists or update state
      store.dispatch("fetchMessageStats");
    };

    onUnmounted(() => {
      document.removeEventListener("open-email-composer", openComposer);
    });

    return {
      isAuthenticated,
      composerModalOpen,
      originalMessage,
      closeComposer,
      handleEmailSent,
    };
  },
};
</script>

<style>
.app-container {
  /* height: 100vh; */
  background-color: #f9fafb;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-wrapper {
  padding-top: 4rem; /* Match the height of the navigation bar */
}
</style>
